const DEFAULT_CAMPAIGN_ID = process.env.GATSBY_DEFAULT_CAMPAIGN_ID;

module.exports = {
    brandInfo: {
        phoneNumber: "18885364210",
        contactEmail: "info@creditwheelsfinance.com",
        address: "10 Lower Spadina Ave, Toronto ON",
        copyright: `© ${new Date().getFullYear()} Credit Wheels Finance`,
        defaultCampaignId: DEFAULT_CAMPAIGN_ID || "21",
    },

    project: "credit-wheels-finance-application",
    name: "Credit Wheels Finance",
    shortName: `CWF`,
    title: `Credit Wheels Application`,
    description: `Get the lowest rates on the best vehicles available!`,
    reportingDomain: "creditwheelsfinance.com",

    siteUrl: "https://www.creditwheelsfinance.com/application",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,
    layout: {
        component: require.resolve("./src/layout/index.jsx"),
        theme: require.resolve("./themes/custom/single-page-theme.js"),
    },
    requiredPartialFields: [
        "firstName",
        "lastName",
    ],
};